<template>
 <section class="sc-o27kl3-0 gsZmuC product-slider-section mt-5">
    <h3 class="mb-3 h3 text-center" style="white-space: pre-line;">محصولات مرتبط</h3>
  <div class="mt-4">
    <div class="sc-d8w7bo-1 jpdybm">
      <div direction="row" class="sc-1r3hge1-0 heMFVq scroll-example">
         <product-vue :list="list" />
       </div>
    </div>
  </div>
</section>
</template>

<script setup>
import ProductVue from '../../item/product.vue';
import axios from 'axios';
import {defineProps,ref,watch,computed} from 'vue'
import { useRoute } from 'vue-router';
let props = defineProps(['ordination_id','item_id']);
let list = ref()
const route = useRoute()
const page = computed(() => route.params.item || 1);

watch(page, async () => {
  await getRelatedList();
}, { immediate: true });


 async function getRelatedList(){
	axios
	.get('https://radap.ir/Backend/api/section/pages/product/related.php?ord_id='+props.ordination_id+'&item_id='+page.value)
	.then(response =>{
		list.value = response.data;
    // verifySelect()
    window.scrollTo(0,0);
	})
}
getRelatedList()
</script>

<style scoped>

</style>